var Point = require('./point')
var Curve = require('./curve')

var getCurveByName = require('./names')

module.exports = {
  Curve: Curve,
  Point: Point,
  getCurveByName: getCurveByName
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ecurve/lib/index.js
// module id = 42
// module chunks = 0